import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="bg-[#FFFBF5] px-6 py-16 md:py-24" data-id="element-1">
      <div className="mx-auto max-w-5xl" data-id="element-2">
        <h2 className="mb-12 text-center text-3xl font-bold text-[#2D2420] md:text-4xl" data-id="element-3">
          Para quién es / para quién NO es
        </h2>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-4">
          {/* For You */}
          <div className="rounded-xl bg-white p-8 shadow-sm ring-1 ring-[#E8DDD4]" data-id="element-5">
            <div className="mb-6 flex items-center gap-3 border-b border-[#E8DDD4] pb-4" data-id="element-6">
              <CheckCircle className="h-8 w-8 text-[#C4704B]" data-id="element-7" />
              <h3 className="font-serif text-2xl font-bold text-[#2D2420]" data-id="element-8">
                Es para ti si:
              </h3>
            </div>
            <ul className="space-y-4 text-[#2D2420]" data-id="element-9">
              <li className="flex items-start gap-3" data-id="element-10">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C4704B]" data-id="element-11" />
                <span data-id="element-12">Te engañaron y te sientes culpable</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-13">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C4704B]" data-id="element-14" />
                <span data-id="element-15">Te confundes en las conversaciones</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-16">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C4704B]" data-id="element-17" />
                <span data-id="element-18">Terminas pidiendo perdón por preguntar</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-19">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C4704B]" data-id="element-20" />
                <span data-id="element-21">Necesitas estructura para volver a tu centro</span>
              </li>
            </ul>
          </div>

          {/* Not For You */}
          <div className="rounded-xl bg-[#FFF3E8] p-8 ring-1 ring-[#E8DDD4]" data-id="element-22">
            <div className="mb-6 flex items-center gap-3 border-b border-[#E8DDD4] pb-4" data-id="element-23">
              <XCircle className="h-8 w-8 text-[#8B7D75]" data-id="element-24" />
              <h3 className="font-serif text-2xl font-bold text-[#8B7D75]" data-id="element-25">
                No es para ti si:
              </h3>
            </div>
            <ul className="space-y-4 text-[#8B7D75]" data-id="element-26">
              <li className="flex items-start gap-3" data-id="element-27">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8B7D75]" data-id="element-28" />
                <span data-id="element-29">Quieres técnicas para espiar, vengarte o manipular</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-30">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8B7D75]" data-id="element-31" />
                <span data-id="element-32">Buscas que alguien te prometa que él cambiará</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-33">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8B7D75]" data-id="element-34" />
                <span data-id="element-35">
                  Estás en peligro físico (primero seguridad y apoyo local)
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}